import React from 'react';
import { Text } from 'components/typography';
import { FormattedMessage } from 'react-intl';
import { Brikk } from 'components/Brikk';
import { useEnableUser } from 'services/admin/enable-user';
import { useAllUsers } from 'services/admin/get-all-users';
import { Button } from 'components/form-elements/buttons/Button';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';
import { DeleteUser } from '../../../Users/components/DeleteUser';
import styles from './style.module.scss';

export const EnableUser = () => {

  const { selectedUser, setSelectedUser } = React.useContext(UserAdministrationModalContext);
  const allUsers = useAllUsers();

  const enableUser = useEnableUser({
    onSuccess: () => {
      setSelectedUser(allUsers.users.find((user) => user.id === selectedUser.id));
    },
  });

  return (
    <div className={styles.container}>

      <Brikk.Heading
        heading="userAdminBrikk"
      />
      
      <Text>
        <FormattedMessage
          id="userIsDisabled"
          values={{
            user: <strong>{selectedUser.email}</strong>,
          }}
        />
      </Text>
     
      <div className={styles.actions}>

        <Button
          type="button"
          onClick={() => enableUser.mutate(selectedUser.id)}
          disabled={enableUser.isLoading || allUsers.isLoading}
          loading={enableUser.isLoading || allUsers.isLoading || enableUser.isSuccess}
        >
          <FormattedMessage
            id="enableUser"
            defaultMessage="Enable"
          />
        </Button>

        <DeleteUser />
      </div>

    </div>
  );
};
